import { z } from "zod";

export const meterNumberSchema = z
  .string()
  .trim()
  .regex(/^\d{11}$|^\d{13}$/, "O contador deve ter 11 ou 13 dígitos.");

export const moneySchema = z.coerce
  .number()
  .positive("O valor deve ser maior que zero.")
  .max(5000, "O valor máximo permitido é 5000 MZN.");

export const loginSchema = z.object({
  username: z.string().trim().min(1, "Utilizador obrigatório."),
  password: z.string().min(1, "Palavra-passe obrigatória."),
});

export const dateRangeSchema = z.object({
  start: z.any(),
  end: z.any(),
});

export function validateWithSchema(schema, payload) {
  const parsed = schema.safeParse(payload);
  if (parsed.success) return parsed.data;
  throw new Error(parsed.error.issues.map((issue) => issue.message).join(" "));
}
